import React, { Component, Fragment } from 'react';
import CardComponent from '../Add-skills/cardComponent';
import { TopicLoader } from '../../Loader/loader'
import './mentors.scss';
// import Mentors from './mentor.json';
import Modal from "react-bootstrap/Modal";
import AddQuery from './Conversation/addQuery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { resetLoading, getMentorList, getNextMentorList, getConversationList, getQDetails, closeDetails, replySent, deleteReply, getMentors, replySentFromAdmin, markasclosed, markasjunk, bookSession } from '../../ActionCreators/AdminAction/managementorAction';
import { clearErrors } from '../../ActionCreators/errorAction';
import InfiniteScroll from 'react-infinite-scroll-component';
import Snackbar from '@mui/material/Snackbar';
import Conversation from './Conversation/conversation';
import QueryDetail from './Conversation/queryDetails';
import { withTranslation } from 'react-i18next';


class MentorsV2 extends Component {
    state = {
        type: 'list',
        open: false,
        activeBtn: 'mentor',
        page: 1,
        query: '',
        redirect: false
    }

    componentDidMount = () => {
        if (this.props.history.location.state?.post) {
            this.setState({
                type: 'question',
                redirect: true
            })
        }
        if (this.props.history.location.state?.view) {
            window.scrollTo(0, 0);
            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            };
            this.setState({
                type: 'view',
                details: this.props.history.location.state,
                redirect: true
            })
        }
        if (localStorage.getItem('role')?.includes('mentor')) {
            this.setState({
                activeBtn: 'conversation',
                pageCount: 1
            })
        }
        else if (this.props.activeBtn === 'conversation') {
            this.setState({
                activeBtn: 'conversation',
                pageCount: 1
            })
        }
        else if (this.props.activeBtn === 'mentor') {
            this.setState({
                activeBtn: 'mentor'
            }, () => {
                this.props.getMentorList(this.state.page, this.state.query);
            })
        }
        localStorage.getItem('role')?.includes('admin') && this.props.getMentors();
    }

    querySearch = (val) => {
        clearTimeout(this.timer);
        this.setState({
            query: val,
            page: 1,
        }, async () => {
            this.timer = setTimeout(this.getSearch, 500);
        }
        );
    }

    getSearch = () => {
        this.props.getMentorList(this.state.page, this.state.query)
    }

    onBtnchange = (e) => {
        this.setState({
            activeBtn: e,
            pageCount: 1,
            page: 1,
            query: ''
        }, () => {
            this.props.resetLoading();
            if (this.state.activeBtn === 'mentor') {
                this.props.getMentorList(this.state.page, this.state.query);
            } else {
                this.props.getConversationList(this.state.pageCount)
            }
        })
    }

    fetchData = () => {
        this.setState({
            page: this.state.page + 1
        }, () => {
            this.props.getNextMentorList(this.state.page, this.state.query)
        })
    }



    openView = (details) => {
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        this.setState({
            type: 'view',
            details
        })
    }

    openPopup = () => {
        this.setState({
            open: true
        })
    }

    closeModal = () => {
        this.setState({
            open: false
        })
    }

    goBack = () => {
        this.setState({
            type: 'list',
            activeBtn: 'conversation'
        })
    }

    goToDetails = (el) => {
        this.setState({
            details: el,
            questionId: el._id
        }, () => {
            this.props.getQDetails(el, el._id);
        })
    }

    replySent = async (obj) => {
        await this.props.replySent(obj);
        await this.props.getQDetails(this.state.details, this.state.questionId);
    }

    replySentFromAdmin = async (obj) => {
        await this.props.replySentFromAdmin(obj);
        await this.props.getQDetails(this.state.details, this.state.questionId);
    }



    snackClosed() {
        this.props.clearErrors();
    }


    render() {
        const { type, details, } = this.state
        const { mentors, isLoading, viewDetails, theme, successEnable, successMessage, successMessageText, t } = this.props
        return (
            <div className='mentor-connect'>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />

                {!viewDetails ?
                    (type === 'list' ?
                        <Fragment>
                            <div className='d-flex justify-content-between align-items-center' style={{ width: window.innerWidth > 767 ? '' : '60%' }}>
                                {window.innerWidth < 767 ? <Fragment><img src='/images/chevron-left.svg' onClick={() => this.props.history.goBack()} alt='' />&nbsp;&nbsp;</Fragment> : null}
                                <div>
                                    <h1>{t('Mentors')}</h1>
                                    {window.innerWidth > 767 && <p>{t('Take your upskilling to the next level by taking guidance from Elite’s list of mentors')}</p>}
                                </div>
                            </div>
                            {window.innerWidth < 767 &&
                                <div>
                                    <p>{t('Take your upskilling to the next level by taking guidance from Elite’s list of mentors')}</p>
                                </div>
                            }
                            <div style={{ marginTop: 6, width: window.innerWidth > 767 ? '' : '95%', borderBottom: '2px solid #e7c15f' }}></div>
                            <div className='d-flex justify-content-between align-items-center mt-2'>
                                <div className='elite-mentors-btns'>
                                    {!localStorage.getItem('role')?.includes('mentor') &&
                                        <Fragment>
                                            <button style={{ backgroundColor: this.state.activeBtn === 'mentor' ? theme.bgColor : '' }} className={this.state.activeBtn === 'mentor' ? 'button-color' : ''} onClick={() => this.onBtnchange('mentor')}>{t('Mentors')}</button>
                                            &nbsp;&nbsp;
                                        </Fragment>
                                    }
                                    <button style={{ backgroundColor: this.state.activeBtn === 'conversation' ? theme.bgColor : '' }} className={this.state.activeBtn === 'conversation' ? 'button-color' : ''} onClick={() => this.onBtnchange('conversation')}>{t('Conversation')}</button>
                                </div>
                                {localStorage.getItem('role')?.includes('mentor') ? null :
                                    window.innerWidth > 767 ?
                                        <button style={{ backgroundColor: theme.bgColor }} onClick={() => this.setState({ type: 'question' })} className='post-btn'><img src='/images/question.svg' alt='' style={{ verticalAlign: 'middle' }} onClick={() => this.setState({ type: 'question' })} /> &nbsp; {t('Post a question')}</button> :
                                        <div className='ask-btn' onClick={() => this.setState({ type: 'question' })} >
                                            <img src='/images/question-white.svg' alt='' style={{ verticalAlign: 'middle' }} />
                                        </div>
                                }
                            </div>
                            {
                                this.state.activeBtn === 'mentor' ?
                                    <div className='elite-mentor-cards'>
                                        <div className="mentor-search" style={{ width: '100%', border: '1px solid #B2B0BF', borderRadius: 0, }} >
                                            <span className="form-control-feedback">
                                                <img src="/images/search.svg" width="14" alt='' />
                                            </span>
                                            <input placeholder={t('Search mentor')} id='search' autoComplete='off'
                                                onChange={(e) => this.querySearch(e.target.value)}
                                                style={{ background: '#fff' }}
                                                value={this.state.query} className='form-control' />
                                        </div>
                                        <InfiniteScroll
                                            dataLength={mentors !== undefined && mentors?.length} //This is important field to render the next data
                                            next={this.fetchData}
                                            hasMore={true}
                                            style={{ overflowX: 'hidden' }}
                                        >
                                            <div className={window.innerWidth > 767 ? 'row mt-2  ' : 'row mt-2'} >

                                                {isLoading ?
                                                    <TopicLoader /> :
                                                    mentors && mentors.map((el, i) => {
                                                        return (

                                                            <div id={`skill${i}`} className={window.innerWidth > 767 ? 'col  pr-0 mt-1 mb-2 d-flex align-self-stretch cursor-pointer' : 'card-align col-6  mt-1 mb-2 d-flex align-self-stretch cursor-pointer'} style={{ marginRight: window.innerWidth > 767 ? 0 : 0, flexGrow: 'unset' }}>
                                                                <div className='card' onClick={() => this.openView(el)} >
                                                                    {el.featured ? <div className='featured'>
                                                                        <img src='/images/star1.svg' alt='' />
                                                                        <p>{t('Featured')}</p>
                                                                    </div> :
                                                                        null
                                                                    }
                                                                    <div className='d-flex justify-content-center align-items-center'>
                                                                        <div className="card__img" >
                                                                            <img src={el.image} alt="" loading="lazy" />

                                                                        </div>
                                                                    </div>
                                                                    <div className="card__body">
                                                                        <h1 className='body-text elipsis' title={el.name}>{el.name}</h1>
                                                                        <h2>{el.designation}</h2>
                                                                        <div className='skills mt-2' style={{ height: 28 }}>
                                                                            <p>{el.skills.map(el => el.title).join(', ')}</p>
                                                                        </div>
                                                                        <button style={{ backgroundColor: theme.bgColor }} className='mt-3' >{t('View & Connect')}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </InfiniteScroll>
                                    </div>
                                    :
                                    <Conversation
                                        goToDetails={this.goToDetails}
                                    />
                            }

                        </Fragment> :
                        type === 'view' ?
                            <Fragment>
                                <div className='mentor-view'>
                                    <div className='mentor-head'>
                                        <img src='/images/left-arrow-white.svg' onClick={() => this.state.redirect ? this.props.history.goBack() : this.setState({ type: 'list' })} style={{ cursor: 'pointer' }} alt='' />
                                        <div className='text-center'>
                                            <h1>{details?.name ? details?.name : `${details?.firstName} ${details?.lastName}`}</h1>
                                            <h2>{details?.designation}</h2>
                                        </div>
                                        <a href={details?.linkedin} target='_blank' rel="noreferrer">
                                            <img src='/images/linkedin-icon.svg' alt='' />
                                        </a>
                                    </div>
                                    <div className='mentor-description pt-4'>
                                        <div className='row ml-1'>
                                            <div className='col-md-4 pl-0'>
                                                <div className='d-flex justify-content-center'>
                                                    <div className='circular-img' style={{ backgroundImage: `url(${details?.image})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover' }}>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-8'>
                                                <div className='mentor-describe'>
                                                    <h4>{details?.profile}</h4>
                                                    <div className='mentor-btn'>
                                                        <a href='https://buy.stripe.com/28o047aBB85J3y8fZ7' target='_blank' rel="noreferrer">
                                                            <button style={{ backgroundColor: theme.bgColor }} onClick={() => this.props.bookSession(details?._id)}>{t('Book a Session for')} $90/hr</button>&nbsp;&nbsp;
                                                        </a>
                                                        {/* <button className='d-flex justify-content-center align-items-center'><img src='/images/play-icon.svg' alt='' /> &nbsp;Watch Intro Video</button> */}

                                                    </div>
                                                    <div style={{ marginTop: 25, width: window.innerWidth > 767 ? '' : '95%', borderBottom: '2px solid #e7c15f' }}></div>
                                                    <div className='d-flex flex-wrap mt-4'>
                                                        {
                                                            details?.skills.map((el, i) => {
                                                                return (
                                                                    <div className='sub mb-2' style={{ border: i % 2 === 0 ? '1px solid #5FBB97' : '1px solid #E7C15F' }}>
                                                                        <p><img src='/images/check-mark-yellow.svg' alt='' /> &nbsp;&nbsp;{el.title}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            details?.featured ?
                                                <div className='endrosement-card'>
                                                    <p>Skills reviewed and endorsed by {details.firstName}</p>
                                                    <CardComponent
                                                        skills={details?.featured_skills}
                                                        type='mentor'
                                                    />
                                                </div> :
                                                null

                                        }

                                    </div>
                                </div>
                                <h4 className='mt-5'>{t('Similar mentors')}</h4>
                                <div className='elite-mentor-cards mt-0'>
                                    <div className={window.innerWidth > 767 ? 'row row-cols-5 mt-2 ' : 'row mt-2'} style={{ marginLeft: window.innerWidth > 767 ? '' : '' }} >
                                        {
                                            mentors && mentors.map((el, i) => {
                                                return (
                                                    <div id={`skill${i}`} className={window.innerWidth > 767 ? 'col  pr-0 mt-1 mb-2 d-flex align-self-stretch cursor-pointer' : 'card-align col-6  mt-1 mb-2 d-flex align-self-stretch cursor-pointer'} style={{ marginRight: window.innerWidth > 767 ? 0 : 0 }}>
                                                        <div className='card'>
                                                            {el.featured ? <div className='featured'>
                                                                <img src='/images/star1.svg' alt='' />
                                                                <p>{t('Featured')}</p>
                                                            </div> :
                                                                null
                                                            }
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <div className="card__img">
                                                                    <img src={el.image} alt="" loading="lazy" />
                                                                </div>
                                                            </div>
                                                            <div className="card__body">
                                                                <h1 className='body-text elipsis' title={el.name}>{el.name}</h1>
                                                                <h2>{el.designation}</h2>
                                                                <div className='skills mt-2'>
                                                                    <p>{el.skills.map(el => el.title).join(', ')}</p>
                                                                </div>
                                                                <button style={{ backgroundColor: theme.bgColor }} className='mt-3'>{t("View & Connect")}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Fragment> :
                            <AddQuery
                                goBack={this.goBack}
                                t={this.props.t}
                                redirect={this.state.redirect}
                            />) :
                    <QueryDetail
                        replies={this.props.replies}
                        // uploadFile={this.props.uploadFile}
                        question={this.props.question}
                        replySent={this.replySent}
                        attachment={this.props.attachment}
                        closeDetails={this.props.closeDetails}
                        deleteReply={this.props.deleteReply}
                        replySentFromAdmin={this.replySentFromAdmin}
                        selectMentors={this.props.selectMentors}
                        successEnable={this.props.successEnable}
                        successMessageText={this.props.successMessageText}
                        markasjunk={this.props.markasjunk}
                        markasclosed={this.props.markasclosed}
                        snackClosed={this.snackClosed}
                        theme={this.props.theme}
                        t={this.props.t}
                    />

                }

                {/* ################# Added modal ########################3 */}
                <Modal
                    show={this.state.open}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    // onHide={this.handleCloseModal}
                    dialogClassName={"confirm-modal"}
                >
                    <div className="p-3 text-center">
                        <h1 style={{ fontSize: 20 }}>This feature is not enabled for this account. Please contact your admin</h1>
                        <div className="save-btn">
                            <button style={{ backgroundColor: theme.bgColor }} onClick={this.closeModal}>Ok</button>
                        </div>
                    </div>
                </Modal>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { isLoading, mentors, conversation, activeBtn, viewDetails, replies, question, selectMentors } = state.manageMentor
    const { successEnable, successMessage, successMessageText } = state.error
    const { theme } = state.account
    return {
        isLoading, mentors, conversation, activeBtn, viewDetails, replies, question, selectMentors, theme,
        successEnable, successMessage, successMessageText
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        resetLoading, getMentorList, getNextMentorList, getConversationList, getQDetails, closeDetails, replySent, deleteReply, getMentors, replySentFromAdmin,
        markasclosed, markasjunk, bookSession,
        clearErrors
    }, dispatch)
}


export default withTranslation('learn')(connect(mapStateToProps, mapDispatchToProps)(MentorsV2))
